import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ----------------Add Project----------------
export const addReviewSchema = Yup.object()
  .shape({
    reviewTo: Yup.mixed()
      .notOneOf([''], Strings.validation.fieldRequired(Strings.field.reviewTo))
      .required(Strings.validation.fieldRequired(Strings.field.reviewTo)),
    description: Yup.string()
      .nullable()
      .test('no-leading-whitespace', 'Description should not start with whitespace', (value) => {
        if (!value) return true;
        return !/^\s/.test(value);
      }),
  })
  .required();
